'use strict';

import _ from 'lodash';

const Verifier = require('./../../system/Verifier');

const StringLengthContrib = (module.exports = {
	type: 'StringLengthVerifierContrib',

	minLength: 1,
	maxLength: 256,

	verify_minLength: function(value) {
		return _.isString(value) && value.length >= this.minLength;
	},

	verify_maxLength: function(value) {
		return _.isString(value) && value.length <= this.maxLength;
	}
});
